import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { OrganisationCategoryValue, WorkflowDialogWidth, WorkflowScope, WorkflowType } from "@common/ADAPT.Common.Model/embed/workflow";
import { WorkflowStep, WorkflowStepGuidancePosition } from "@common/ADAPT.Common.Model/embed/workflow-step";
import { RoleInOrganisation } from "@common/ADAPT.Common.Model/organisation/connection";
import { ImplementationKitArticle } from "@common/implementation-kit/implementation-kit-article.enum";
import { SeedEntity } from "@org-common/lib/purpose-vision/common-purpose-vision.service";
import { buildLocalWorkflow } from "@org-common/lib/workflow/workflow.interface";
import { WorkflowIdentifier } from "@org-common/lib/workflow/workflow-identifier.enum";
import { TourIdentifier } from "../../../tours/tour-identifier.enum";
import { ISeedStepData } from "../../shared/define-seed/seed.interface";
import { createActivityBriefWorkflowStep } from "../../workflow-utilities";
import { VisionSeed, VisionSeeds } from "./vision-seeds";

export const alignOwnersVisionWorkflowName = "Align owners & vision";

const time = "3 hours";
const people = "Owners";
const mindset = "Reflective";

function buildVisionAlignmentWorkflow(standalone: boolean) {
    return buildLocalWorkflow({
        name: alignOwnersVisionWorkflowName,
        workflowId: `${WorkflowIdentifier.AlignOwnersVision}Define${standalone}`,
        type: WorkflowType.Workflow,
        time,
        people,
        mindset,
        dialogWidth: WorkflowDialogWidth.ExtraLarge,
        featuresToEnable: [FeatureName.PurposeAndVision],
        showBreadcrumbs: true,
        steps: [
            createActivityBriefWorkflowStep(alignOwnersVisionWorkflowName, ImplementationKitArticle.AlignOwnersVisionActivityBrief, undefined, undefined),
            {
                name: "The 4 zones",
                ordinal: 1,
                allowBack: true,
                canSkip: false,
                articleSlug: ImplementationKitArticle.AlignOwnersVisionActivityBriefPart2,
            },
            ...VisionSeeds.map((seed, i, seeds) => {
                return {
                    name: seed.question,
                    ordinal: 2 + i,
                    allowBack: true,
                    canSkip: false,
                    articleSlug: seed.articleSlug,
                    articlePosition: WorkflowStepGuidancePosition.Left,
                    componentSelector: "adapt-define-seed",
                    customData: { seed, seeds, entity: SeedEntity.Vision } as ISeedStepData<VisionSeed>,
                } as WorkflowStep;
            })],
    });
}

export const alignOwnersVisionWorkflow = buildVisionAlignmentWorkflow(false);
export const alignOwnersVisionStandaloneWorkflow = buildVisionAlignmentWorkflow(true);

export const alignOwnersVisionJourneyWorkflow = buildLocalWorkflow({
    name: alignOwnersVisionWorkflowName,
    workflowId: WorkflowIdentifier.AlignOwnersVision,
    type: WorkflowType.Journey,
    time,
    people,
    mindset,
    dialogWidth: WorkflowDialogWidth.ExtraLarge,
    overview: "Align the owners on their key points, enabling the leadership team to fully articulate the businesses vision",
    articleSlug: ImplementationKitArticle.AlignOwnersVisionOutcomes,
    wrapUpSlug: ImplementationKitArticle.AlignOwnersVisionWrapUp,
    category: OrganisationCategoryValue.Foundation,
    wrapUpGuidedTourIdentifier: TourIdentifier.AlignOwnersVisionWrapUpTour,
    scope: WorkflowScope.Team,
    featuresToEnable: [FeatureName.PurposeAndVision],
    moduleFeaturesRequired: [FeatureName.CompassOwnerAlignment],
    ordinal: 20,
    requiredRoles: [RoleInOrganisation.OwnerLeader],
    workflows: [alignOwnersVisionWorkflow],
});
